import styled from "styled-components"

export default {
    "ParentWrapper": styled.div`
        min-width: 960px;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: ${({ theme }) => theme.color.grey1};

        @media (max-width: 1280px) {
            min-width: 820px;
            width: auto;
        }
    `,
}